interface GenerateBrandguideUrlOptions {
  slug: string;
  cname?: string | null;
  organizationKey?: string | null;
  v2?: boolean | null;
}

/**
 * Generate the correct Brandguide URL for either v1 or v2 Brandguides.
 * It requires the `BFG` window global being available.
 * 
 * @param options GenerateBrandguideUrlOptions
 * @returns string
 */
export const generateBrandguideUrl = (options: GenerateBrandguideUrlOptions): string => {
  const { cname, organizationKey, slug, v2 } = options;

  if (v2) {
    return `${BFG.brandguideUrl}?redirect=${slug}${cname ? `&cname=${cname}` : ''}${organizationKey ? `&org_key=${organizationKey}` : ''}`;
  } else if (cname) {
    return `https://${cname}/${slug}`;
  }  else {
    return `${BFG.brandguideV1Url}/${slug}`;
  }
};